import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=083badf0&"
import script from "./editDialog.vue?vue&type=script&lang=ts&"
export * from "./editDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports